import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { UrlImage } from "../../Core/ApiEndPoint";
import { useTranslation } from "react-i18next";

const PropertySlider = ({ profileData }) => {
    const { t } = useTranslation();
    const [thumbsSwiper, setThumbsSwiper] = React.useState(null);

    const slides = profileData?.multiple_images || [];
    const [slidesPerView, setSlidesPerView] = React.useState(6);
    const showNav = slides.length > slidesPerView;


    const [loadedImages, setLoadedImages] = useState({});
    const [loaded, setLoaded] = useState({});

    const handleImageLoad = (index) => {
        setLoadedImages((prev) => ({ ...prev, [index]: true }));
    };
    const handLoad = (index) => {
        setLoaded((prev) => ({ ...prev, [index]: true }));
    };

    return (
        <div className="ps-root">

            {/* MAIN FULL-WIDTH SLIDER */}
            <Swiper
                loop={true}

                thumbs={{ swiper: thumbsSwiper }}
                modules={[Navigation, Thumbs]}
                className="ps-main-slider"
            >
                {profileData?.multiple_images?.map((src, index) => (
                    <SwiperSlide key={index}>
                        {!loadedImages[index] && (
                            <div className="card-image-skeleton">
                                <span className="card-image-spinner"></span>
                            </div>
                        )}
                        <img src={UrlImage + src}
                            alt={UrlImage + src}
                            loading="lazy"
                            className="ps-main-img"
                            onLoad={() => handleImageLoad(index)}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* ROUND ARROWS */}


            {/* THUMBNAILS */}
            <div className={`container swiper-wrapper-container ${showNav && "showNav"} `} style={{ position: "relative" }}>
                <Swiper
                    loop={slides.length > slidesPerView}
                    spaceBetween={10}
                    watchOverflow={false}
                    watchSlidesProgress
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    navigation={
                        showNav
                            ? { nextEl: ".ps-next", prevEl: ".ps-prev" }
                            : false
                    }
                    onSwiper={(swiper) => {
                        setThumbsSwiper(swiper);
                        setSlidesPerView(swiper.params.slidesPerView);
                    }}
                    onBreakpoint={(swiper, params) => {
                        setSlidesPerView(params.slidesPerView);
                    }}
                    modules={[Thumbs, Autoplay, Navigation]}
                    className="ps-thumb-slider"
                    breakpoints={{
                        0: { slidesPerView: 2 },
                        480: { slidesPerView: 3 },
                        768: { slidesPerView: 4 },
                        1024: { slidesPerView: 6 },
                    }}
                >
                    {slides.map((src, index) => (
                        <SwiperSlide key={index}>
                            {!loaded[index] && (
                                <div className="card-image-skeleton">
                                    <span className="card-image-spinner"></span>
                                </div>
                            )}
                            <img
                                src={UrlImage + src}
                                alt=""
                                className="ps-thumb-img"
                                onLoad={() => handLoad(index)}

                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
                {showNav && (
                    <>
                        <button className="ps-prev">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M15 18L9 12L15 6"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>

                        <button className="ps-next">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M9 6L15 12L9 18"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </>
                )}

            </div>
        </div>
    );
};

export default PropertySlider;
